import { AccessMode } from "../models/constants/accessMode";

export async function copyToClipboard(
  accessMode: string,
  value: unknown,
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: () => void;
    onError?: () => void;
  } = {}
) {
  if (typeof value !== "string") {
    onError?.();
    return;
  }

  try {
    debugger;
    // APP
    if (accessMode === AccessMode.App) {
      window.location.href =
        "appscheme://buttonclick/copy/" +
        encodeURIComponent(value);

      onSuccess?.();
      return;
    }

    // WEB
    if (!navigator?.clipboard?.writeText) {
      console.error("Clipboard API not supported");
      onError?.();
      return;
    }

    await navigator.clipboard.writeText(value);

    onSuccess?.();
  } catch {
    onError?.();
  }
}